import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useApiCall } from "../services/api";
import { useGlobalModal } from "../context/SuccessModalProvider";
import { useDispatch } from "react-redux";
import { setAuthLogin } from "../redux/auth/loginSlice";
import { MdOutlineArrowOutward } from "react-icons/md";
import Verification from "../components/models/Verification";
import PrimaryButton from "../components/Forms/PrimaryButton";
import { Form, Input } from "antd";
import { formRules, routePrefix } from "../constant";
import AppLogo from "../components/AppLogo";

const ForgotPassword = ({ pageType = "sales" }) => {
  const dispatch = useDispatch();
  const { postApi, loading } = useApiCall();
  const { showPopup } = useGlobalModal();
  const location = useLocation();
  const navigate = useNavigate();

  const showNextPage = location.state?.nextPage;
  const username = location.state?.username || "";

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  // 🔹 Handle submit for both stages
  const handleSubmit = async (values) => {
    if (showNextPage) {
      const { password, confirmPassword } = values;
      if (password !== confirmPassword) {
        return showPopup({
          title: null,
          content: <span className="custom-modal-title">Passwords do not match</span>,
          className: "custom-success-modal",
        });
      }

      const payload = {
        ...values,
        username,
        type: username.includes("@") ? "email" : "phone",
      };

      const res = await postApi("customer/reset-password", payload, true);
      if (res?.status) {
        dispatch(setAuthLogin(res.data));
        navigate(`${routePrefix[pageType]}`);
      }
    } else {
      const { username } = values;
      const type = username.includes("@") ? "email" : "phone";
      const res = await postApi(
        "customer/forgot-password-send-otp",
        { username, type, deviceType: pageType==='customer'?undefined:"Web" },
        true
      );
      if (res?.status) {
        navigate(`${routePrefix[pageType]}/otp-verify`, {
          state: { type, username, loginType: "resetPassword" },
        });
      }
    }
  };

  // 🔹 Shared form layout styles
  const inputClass =
    "h-[47.6px] bg-[#FFFFFF] border border-[#D9D9D9] text-[#000000] text-base rounded-2xl w-full p-3.5 focus:outline-none focus:border-transparent";

  // 🔹 Shared layout container
  const AuthCard = ({ children, title }) => (
    <div className="border w-[90%] md:w-[60%] lg:w-[40%] p-[36px] rounded-[32px] bg-[#FFFFFFCC] backdrop-blur-154">
      <AppLogo />
      <p className="text-[45px] md:text-[50px] my-4 font-normal text-[#353535] font-abhaya">
        {title}
      </p>
      {children}
    </div>
  );

  return (
    <div className="container-full">
      <div className="min-h-screen bg-[#A33434] bg-style flex justify-center items-center">
        <AuthCard title={showNextPage ? "Set Password" : "Forgot Password?"}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            className="max-w-full mx-auto"
            requiredMark={false}
            initialValues={{ username }}
          >
            {showNextPage ? (
              <>
                {/* Password */}
                <Form.Item
                  name="password"
                  label={
                    <span className="block mb-2 text-xl font-manrope font-normal text-[#000000]">
                      Enter Password
                    </span>
                  }
                  rules={formRules.password}
                >
                  <Input.Password className={inputClass} placeholder="" maxLength={20} />
                </Form.Item>

                {/* Confirm Password */}
                <Form.Item
                  name="confirmPassword"
                  dependencies={["password"]}
                  label={
                    <span className="block mb-2 text-xl font-manrope font-normal text-[#000000]">
                      Confirm Password
                    </span>
                  }
                  rules={formRules.confirmPass("password")}
                >
                  <Input.Password className={inputClass} placeholder="" maxLength={20} />
                </Form.Item>

                <div className="w-full mt-4 flex justify-center">
                  {/* <button
                    type="submit"
                    className="text-[#ffffff] ml-[-34px] font-manrope relative bg-[#A33434] hover:bg-red-800 border-none font-bold rounded-full text-xl w-full sm:w-auto px-6 py-2.5 text-center"
                  >
                    Save{" "}
                    <span className="bg-[#A33434] absolute top-[2px] right-[-47px] hover:bg-red-800 p-2 rounded-full flex items-center justify-center">
                      <MdOutlineArrowOutward className="w-8 h-8" />
                    </span>
                  </button> */}
                  <PrimaryButton
                    text="Save"
                    type="submit"
                    className="me-[30px]"
                    loading={loading}
                  />
                </div>
              </>
            ) : (
              <>
                {/* Username Input */}
                <Form.Item
                  name="username"
                  label={
                    <span className="block mb-2 text-xl font-manrope font-normal text-[#000000]">
                      Email / Phone Number
                    </span>
                  }
                  rules={formRules.required}
                >
                  <Input className={inputClass} placeholder="" />
                </Form.Item>

                <div className="w-full mt-4 flex justify-center">
                  <PrimaryButton
                    text="Proceed"
                    type="submit"
                    className="me-[30px]"
                    loading={loading}
                  />
                </div>
              </>
            )}
          </Form>
        </AuthCard>

        <Verification isOpen={isModalOpen} closeModal={() => setIsModalOpen(false)} />
      </div>
    </div>
  );
};

export default ForgotPassword;
